var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSummaryLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.8542 3H6.30859C5.75631 3 5.30859 3.44772 5.30859 4V16H2.30859V19C2.30859 20.66 3.64859 22 5.30859 22H17.3086C18.9686 22 20.3086 20.66 20.3086 19V16H18.3086V19C18.3086 19.55 17.8586 20 17.3086 20C16.7586 20 16.3086 19.55 16.3086 19V16H7.30859V5H12.8996C13.0477 4.24935 13.3827 3.56585 13.8542 3ZM5.30859 20C4.75859 20 4.30859 19.55 4.30859 19V18H14.3086V20H5.30859Z",
    fill: "#6A7F9F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.9753 7.125V5.75C19.9753 4.23737 18.7753 3 17.3086 3C15.8419 3 14.6419 4.23737 14.6419 5.75V7.125C13.9086 7.125 13.3086 7.74368 13.3086 8.5V12.625C13.3086 13.3813 13.9086 14 14.6419 14H19.9753C20.7086 14 21.3086 13.3813 21.3086 12.625V8.5C21.3086 7.74368 20.7086 7.125 19.9753 7.125ZM18.6419 7.125H15.9753V5.75C15.9753 4.99368 16.5753 4.375 17.3086 4.375C18.0419 4.375 18.6419 4.99368 18.6419 5.75V7.125Z",
    fill: "#038355"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSummaryLock);
export default __webpack_public_path__ + "static/media/summary-lock.8fc76f014e68d3d44bd9566010b08339.svg";
export { ForwardRef as ReactComponent };